/**
 * Alkalmazásszintű konfiguráció.
 *
 * A Client ID kétféleképp adható meg, ebben a sorrendben:
 *  1. `public/config.js` → `window.BITSQUAD_MD_CONFIG` — futásidejű, a szerveren
 *     szerkeszthető, nem kell hozzá új build. **Ez az ajánlott.**
 *  2. `.env.production` → `VITE_GOOGLE_CLIENT_ID` — buildbe égetve, tartaléknak.
 *
 * Így a `dist/` kitelepíthető azelőtt, hogy a Google-projekt elkészülne: utána elég
 * a `config.js` egy sorát átírni a szerveren.
 */
interface RuntimeConfig {
  clientId?: string;
  hostedDomain?: string;
}

declare global {
  interface Window {
    BITSQUAD_MD_CONFIG?: RuntimeConfig;
  }
}

const runtime: RuntimeConfig = window.BITSQUAD_MD_CONFIG ?? {};

export const CONFIG = {
  clientId: runtime.clientId || (import.meta.env.VITE_GOOGLE_CLIENT_ID ?? ''),
  hostedDomain: runtime.hostedDomain || (import.meta.env.VITE_GOOGLE_HD ?? 'bitsquad.dev'),
  appName: 'Bitsquad MD',
  scopes: [
    'https://www.googleapis.com/auth/drive.file',
    'https://www.googleapis.com/auth/drive.install',
  ].join(' '),
  /** Autosave: ennyi tétlenség után mentünk. */
  autosaveIdleMs: 2000,
  /** Autosave: legkésőbb ennyi idő után mindenképp mentünk. */
  autosaveMaxMs: 30_000,
  /** E fölött figyelmeztetünk, hogy lassulhat a szerkesztő. */
  largeFileBytes: 2 * 1024 * 1024,
  /** E fölött csak olvasó nézetet adunk. */
  hugeFileBytes: 10 * 1024 * 1024,
  markdownMime: 'text/markdown',
} as const;

/** Be van-e kötve a Google projekt? A kezdőoldal önellenőrzése használja. */
export function isConfigured(): boolean {
  return /\.apps\.googleusercontent\.com$/.test(CONFIG.clientId);
}
